import React from 'react'
import PropTypes from 'prop-types'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import FacebookIcon from '../assets/img/png/social_icon_facebook.png'
import InstagramIcon from '../assets/img/png/social_icon_instagram.png'
import YoutubeIcon from '../assets/img/png/social_icon_youtube.png'
import TikTokIcon from '../assets/img/png/social_icon_tiktok.png'
import TwitterIcon from '../assets/img/png/social_icon_twitter.png'
import LinkedInIcon from '../assets/img/png/social_icon_linkedin.png'

const SocialLinks = ({ classes, linkClasses = '', children }) => {
  const baseClasses = linkClasses ? `links ${linkClasses}` : `links`

  return (
    <div className={classes}>
      <span className='social'>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://www.facebook.com/attn'
          target='_blank'
        >
          <img src={FacebookIcon} alt='Facebook' />
        </OutboundLink>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://instagram.com/attndotcom'
          target='_blank'
        >
          <img src={InstagramIcon} alt='Instagram' />
        </OutboundLink>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://www.youtube.com/c/attn'
          target='_blank'
        >
          <img src={YoutubeIcon} alt='YouTube' />
        </OutboundLink>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://www.tiktok.com/@attn'
          target='_blank'
        >
          <img src={TikTokIcon} alt='TikTok' />
        </OutboundLink>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://twitter.com/attn'
          target='_blank'
        >
          <img src={TwitterIcon} alt='Twitter' />
        </OutboundLink>
        <OutboundLink
          className={`${baseClasses}`}
          href='https://www.linkedin.com/company/attn'
          target='_blank'
        >
          <img src={LinkedInIcon} alt='LinkedIn' />
        </OutboundLink>
      </span>
      {children}
    </div>
  )
}

SocialLinks.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
  linkClasses: PropTypes.string
}

export default SocialLinks



// WEBPACK FOOTER //
// ./src/components/social-links-new.js